import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goto, goToView } from '../../../../actions/historyActions';
import EmmaNavTitle from '../../../../components/EmmaNavTitle';
import {
  getUniqueId,
  getValidToken,
  isApp,
  resolveLocalizedText,
} from '../../../../utils';
import CustomerProfileTitle from '../../components/CustomerProfileTitle';
import { getCustomerProfileResetUsenameOrPasswordConfirmConfig } from '../../selectors/customerProfileResetUNOrPWConfirmSelectors';
import {
  getCustomerProfileUsenameCurTab,
  getCustomerProfileUsenameEmail,
  getCustomerProfileUsenameMobile,
} from '../../selectors/customerProfileResetUsenameSelectors';
import {
  RESET_USER_NAME_EMAIL_TYPE,
  RESET_USER_NAME_MOBILE_TYPE,
} from '../../constants/constants';
import './style.scss';
import { getErrorCode } from '../../utils';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import env from '../../../../env';
import { getSelectedPolicy } from '../../selectors/changeContactSelector';
import { passPath } from '../../../../utils/emmaUrlConverter';

export interface ErrorCodePageContainerProps {
  navTitle: string;
  title: string;
  desc: string;
  buttons: any;
  selectedPolicy: string;
}

export interface ErrorCodePageContainerState {}

export class ErrorCodePageContainer extends Component<
  ErrorCodePageContainerProps,
  ErrorCodePageContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // const { curUserNameTab } = this.props
    // !curUserNameTab && goto('emma-customer-profile-resetusenameorpassword')
  }

  onGoto = (item: any) => {
    const { selectedPolicy } = this.props;
    if (item.deepLink && item.deepLink.query && item.deepLink.query.url) {
      const linkUrl = passPath(
        item.deepLink.query.url.replace('${policyNumber}', selectedPolicy),
        '/renewalupdate',
      );

      if (item.deepLink.host && item.deepLink.host === 'emma-webview') {
        if (isApp()) {
          const url = `${linkUrl}`;
          goToView(url);
        } else {
          goto(linkUrl);
        }
      } else {
        goto(linkUrl);
      }
    }
  };

  render() {
    const { navTitle, title, desc, buttons } = this.props;
    return (
      <div className="error-code-page-container emma-stylesheet-grid-system">
        <EmmaNavTitle
          title={navTitle}
          component={<CustomerProfileTitle customerTitle={navTitle} />}
        />
        <div className="error-code-page-container-text">{title}</div>
        <div className="error-code-page-container-desc">{desc}</div>

        <div className="error-code-page-container-button">
          {buttons &&
            buttons.map((item: any) => {
              return (
                <div className="error-code-page-container-button-div">
                  <button
                    className={item.className}
                    data-enable-ga
                    data-ga-type="button"
                    onClick={() => this.onGoto(item)}
                  >
                    {item.label ? resolveLocalizedText(item.label) : ''}
                  </button>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const { error_code, feature_id } = ownProps.match.params;
    const errorCodeConfig = getErrorCode(error_code, state, feature_id);
    const selectedPolicy = getSelectedPolicy(state);
    return {
      navTitle: errorCodeConfig.navTitle
        ? resolveLocalizedText(errorCodeConfig.navTitle)
        : '',
      title: errorCodeConfig.title
        ? resolveLocalizedText(errorCodeConfig.title)
        : '',
      desc: errorCodeConfig.desc
        ? resolveLocalizedText(errorCodeConfig.desc)
        : '',
      buttons: errorCodeConfig.buttons ? errorCodeConfig.buttons : [],
      selectedPolicy,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  ErrorCodePageContainer.mapStateToProps,
  ErrorCodePageContainer.mapDispatchToProps,
)(ErrorCodePageContainer);
